import { useState } from "react";
import { motion } from "framer-motion";
import { ArrowUpRight, Calendar } from "lucide-react";
import { BLOG_POSTS } from "./content";
import BlogDialog from "./BlogDialog";

export default function Blog() {
  const [selected, setSelected] = useState(null);

  return (
    <section
      id="blog"
      data-testid="blog-section"
      className="relative py-24 sm:py-32 bg-[var(--ab-bg-soft)]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6 mb-14">
          <div className="max-w-2xl">
            <span className="ab-chip">Blog</span>
            <h2 className="font-display mt-5 text-4xl sm:text-5xl lg:text-6xl font-extrabold text-[var(--ab-navy)] leading-[1.05]">
              Dijital pazarlama <span className="ab-text-gradient">ipuçları</span>.
            </h2>
            <p className="mt-5 text-lg text-slate-600">
              Sektörün nabzını tutan içerikler, rehberler ve vaka çalışmaları.
              Yazıya tıklayarak tamamını okuyabilirsiniz.
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {BLOG_POSTS.map((p, i) => (
            <motion.button
              type="button"
              key={p.slug}
              onClick={() => setSelected(p)}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.6, delay: i * 0.08 }}
              data-testid={`blog-card-${i}`}
              className="group ab-card overflow-hidden flex flex-col text-left cursor-pointer focus:outline-none focus:ring-2 focus:ring-[var(--ab-blue)] focus:ring-offset-2"
              aria-label={`${p.title} yazısını aç`}
            >
              <div className="aspect-[16/10] overflow-hidden bg-slate-100">
                <img
                  src={p.img}
                  alt={p.title}
                  loading="lazy"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                />
              </div>
              <div className="p-6 flex-1 flex flex-col">
                <div className="flex items-center gap-3 text-xs">
                  <span className="font-semibold text-[var(--ab-blue)] uppercase tracking-wider">
                    {p.category}
                  </span>
                  <span className="text-slate-400 flex items-center gap-1">
                    <Calendar className="h-3 w-3" />
                    {p.date}
                  </span>
                </div>
                <h3 className="font-display mt-3 text-xl font-bold text-[var(--ab-navy)] leading-snug group-hover:text-[var(--ab-blue)] transition-colors">
                  {p.title}
                </h3>
                <p className="mt-3 text-sm text-slate-600 leading-relaxed flex-1">
                  {p.excerpt}
                </p>
                <div className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-[var(--ab-navy)] group-hover:text-[var(--ab-blue)] transition-colors">
                  Yazıyı oku
                  <ArrowUpRight className="h-4 w-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
                </div>
              </div>
            </motion.button>
          ))}
        </div>
      </div>

      <BlogDialog
        post={selected}
        open={!!selected}
        onOpenChange={(o) => !o && setSelected(null)}
      />
    </section>
  );
}
